import { render, staticRenderFns } from "./IncomeStat.vue?vue&type=template&id=6a4e3546&scoped=true"
import script from "./IncomeStat.vue?vue&type=script&lang=js"
export * from "./IncomeStat.vue?vue&type=script&lang=js"
import style0 from "./IncomeStat.vue?vue&type=style&index=0&id=6a4e3546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e3546",
  null
  
)

export default component.exports